import angular from 'angular';
import AnnouncementListComponent from './announcement-list-component';

export default angular.module('announcement-list', []).component('announcementList', new AnnouncementListComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-list/announcement-list-module.js